import { Grid } from '@mui/material';
import styled from 'styled-components';

export const StyledGrid = styled(Grid)`
  margin-top: 20px;
`;
